import createHistory from 'history/createBrowserHistory';
import configureStore from './configurestore';

const initialState = {};

const history = createHistory();
const store = configureStore(initialState, history);

export default store;
